export default {"src":"https://edhrecstatic.com/_next/static/media/moxfield.d8e986ee.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};